//import Utils from '../HlsUtils';
import MsCryptoWrapper from './MsCryptoWrapper';
import { logger } from '../hlsjs/utils/logger';

class WebCryptoWrapper {

	static getSubtle() {
		let subtle;

		try {
			const browserCrypto = crypto || self.crypto;
			subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
		}
		catch (e) {}

		if( !subtle ) {
			if( MsCryptoWrapper.isSupported() ) {
				subtle = new MsCryptoWrapper();
			}
		}

		return subtle;
	}

	/**
	 * NOTE: this returns Promise(Boolean)
	 */
	static isSupportedAsync() {
		let subtle = WebCryptoWrapper.getSubtle();
		let supported = Promise.resolve(false);

		// we actually need to test to see if it works. NOTE: this results in a Promise!
		if( subtle ) {
			try {
				supported = subtle.importKey(
					'raw',
					new Uint8Array(16),
					{ name: 'AES-CBC' },
					false,
					['encrypt', 'decrypt']
				)
				.then( () => {
					// we were able to importKey, assume WebCrypto is functioning
					return true;
				})
				.catch( (/*err*/) => {
					// unable to importKey, assume WebCrypto is busted.
					//logger.warn( `WebCryptoWrapper.isSupported: error while testing
					// WebCrypto, WebCrypto will be disabled : ${err.message}`, err );
					return false;
				});
			}
			catch(err) {
				// in theory this shouldn't happen... but bad WebCrypto implementations sometimes throw.
				logger.warn( `WebCryptoWrapper.isSupported: Unexpected error while testing WebCrypto : ${err.message}`, err );
				supported = Promise.resolve(false);
			}
		}

		return supported;
	}

	/**
	 * NOTE: subtle may be defined, but non-functional when insecure-origin in this case, this will not
	 * throw. you need to resolve isSupportedAsync to know if WebCrypto is truly supported.
	 */
	constructor() {

		let subtle = WebCryptoWrapper.getSubtle();

		if( !subtle ) {
			// please note: if subtle exists, but is not supported, say, because of insecure-origin
			// policy this will not throw.
			throw new Error('WebCryptoWrapper: no WebCrypto implementation available');
		}

		this.crypto = subtle;
	}

	importKey( format, keyData, algo, extractable, usages ) {
		try {
			if( keyData.length !== 16 ) {
				throw new Error( `WebCryptoWrapper.importKey, invalid key length ${keyData.length}`);
			}

			return this.crypto.importKey(format, keyData, algo, extractable, usages );
		}
		catch(err) {
			return Promise.reject(err);
		}
	}

	decrypt( algorithm, key, data ) {
		try {
			if( data.byteLength % 16 !== 0 ) {
				throw new Error( `WebCryptoWrapper.decrypt, data.byteLength must be modulo-16 ${data.byteLength}`);
			}

			return this.crypto.decrypt( algorithm, key, data );
		}
		catch(err) {
			return Promise.reject(err);
		}
	}

	encrypt( algorithm, key, data ) {
		try {
			return this.crypto.encrypt( algorithm, key, data );
		}
		catch(err) {
			return Promise.reject(err);
		}
	}
}

export default WebCryptoWrapper;



// WEBPACK FOOTER //
// ./src/aes/WebCryptoWrapper.js